import React from "react";
import { RouteDefinitions } from "./routes.path";
import { ScanPage } from "../pages/ScanPage/ScanPage";
import { ConfirmPage } from "../pages/ConfirmPage/ConfirmPage";
import { DevicesPage } from "../pages/DevicesPage/DevicesPage";
import { DeviceDetailPage } from "../pages/DeviceDetailPage/DeviceDetailPage";
import { CompanyRegisterPage } from "../pages/CompanyRegisterPage/CompanyRegisterPage";
import { CompanyDetailPage } from "../pages/CompanyDetailPage/CompanyDetailPage";
import { CompanyEditPage } from "../pages/CompanyEditPage/CompanyEditPage";
import { InvitationPage } from "../pages/InvitationPage/InvitationPage";
import { LicensePage } from "../pages/LicensePage/LicensePage";
import { LicenseUpgradePage } from "../pages/LicenseUpgradePage/LicenseUpgradePage";
import { ProfilePage } from "../pages/ProfilePage/ProfilePage";

type RouteConfig = {
  key: string;
  path: string;
  element: React.ReactElement;
};

const createRoute = (
  key: keyof typeof RouteDefinitions,
  element: React.ReactElement,
): RouteConfig => ({
  key,
  path: RouteDefinitions[key].path,
  element,
});

export const UserRoutes: RouteConfig[] = [
  createRoute("SCAN", <ScanPage />),
  createRoute("CONFIRM", <ConfirmPage />),
  createRoute("DEVICES", <DevicesPage />),
  createRoute("DEVICE_DETAIL", <DeviceDetailPage />),
  createRoute("COMPANY_REGISTER", <CompanyRegisterPage />),
  createRoute("COMPANY_DETAIL", <CompanyDetailPage />),
  createRoute("COMPANY_EDIT", <CompanyEditPage />),
  createRoute("INVITATION", <InvitationPage />),
  createRoute("LICENSE", <LicensePage />),
  createRoute("LICENSE_UPGRADE", <LicenseUpgradePage />),
  createRoute("PROFILE", <ProfilePage />),
];
